export enum CtasType {
  CLOSE = 'CLOSE',
  IGNORE = 'IGNORE',
  BACK_CONTINUE = 'BACK_CONTINUE',
}

export const KEEP_ANYWAY = 'KeepAnyway';
